/* entry file */
import Vuex from 'vuex';
import Vue from 'vue';
import qs from 'qs';
import _ from 'lodash';
import config from '@/config/index';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user: localStorage.getItem(`${config.appName}_user`)
      ? JSON.parse(localStorage.getItem(`${config.appName}_user`)) : '',
    token: localStorage.getItem(`${config.appName}_token`),
    defaultLocale: 'fr',
    data: {
      projects: [],
      resources: [],
      tasks: [],
      models: []
    }
  },
  mutations: {
    projects(state, projects) {
      state.data.projects = projects;
    },

    resources(state, resources) {
      state.data.resources = resources;
    },

    tasks(state, tasks) {
      state.data.tasks = tasks;
    },

    models(state, models) {
      state.data.models = models;
    },

    user(state, user) {
      state.user = user;
      App.user = user;
      localStorage.setItem(`${config.appName}_user`, JSON.stringify(user));
    },

    token(state, token) {
      this._vm.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
      this._vm.$http.defaults.headers.Authorization = `Bearer ${token}`;
      state.token = token;
      localStorage.setItem(`${config.appName}_token`, token);
    },

    commitData(state, key, value) {
      state.data[key] = value;
    }
  },
  getters: {
    getTasks(state) {
      return state.tasks;
    }
  },
  actions: {
    logout({
      commit
    }) {
      delete App.user;
      commit('user', '');
      commit('token', '');
      return true;
    },

    refreshUser({
      commit
    }) {
      const q = this._vm.$http.get('/auth/user');
      q.then((res) => {
        App.user = res.data.user;
        localStorage.setItem(`${config.appName}_user`, JSON.stringify(res.data.user));
        commit('user', App.user);
      }).catch((err) => {
        console.warn(err);
        this._vm.$notify({
          title: err.response ? err.response.data : err,
          type: 'warning'
        });
      });
      return q;
    },

    getDynamicPages({
      commit
    }) {
      const promise = this._vm.$http.get('/models');
      promise
        .then((res) => {
          const models = res.data.body
            .map((model) => {
              model.title = _.startCase(model.name);
              return model;
            });
          commit('models', models);
        })
        .catch((err) => {
          console.error(err);
        });
      return promise;
    },

    getTasks({
      commit,
      state
    }, query) {
      query = query || {};
      this._vm.$http
        .get('/crud/project_tasks', {
          params: query,
          paramsSerializer(params) {
            return qs.stringify(params, {
              arrayFormat: 'repeat'
            });
          }
        })
        .then((res) => {
          const tasks = res.data.body.map((task) => {
            const project = state.data.projects.find((p) => task.projectId === p._id);
            task.project_name = project ? project.code || project.name : 'NOT FOUND';
            return task;
          });

          commit('tasks', tasks);
        })
        .catch((err) => {
          console.warn(err);
        });
    }
  }
});

export default store;
